import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faSync, faPlus, faTimes, faImage, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import { fetchUsuario, getUsuario } from '../../user';
import '../ServiciosData/ServiciosData.css';
import imageIcon from '../../../images/imageIcon.png';
import { Link as Anchor } from "react-router-dom";
import TallerDiasData from './TallerDiasData';

export default function TalleresData() {
    const [talleres, setTalleres] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtroId, setFiltroId] = useState('');
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [visibleCount, setVisibleCount] = useState(50);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalEditarVisible, setModalEditarVisible] = useState(false);
    const [selectedSection, setSelectedSection] = useState('texto');
    const [tallerEditar, setTallerEditar] = useState({});

    // catálogos
    const [programas, setProgramas] = useState([]);
    const [instituciones, setInstituciones] = useState([]);
    const [salas, setSalas] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [terapeutas, setTerapeutas] = useState([]);
    const [todosTerapeutas, setTodosTerapeutas] = useState([]);
    const [poblaciones, setPoblaciones] = useState([]);
    const [imagenPreview, setImagenPreview] = useState(null);
    const [imagenFile, setImagenFile] = useState(null);

    // estados de validación
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    // formulario crear
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [idPrograma, setIdPrograma] = useState('');
    const [idCategoria, setIdCategoria] = useState('');
    const [tipo, setTipo] = useState('interno');
    const [cupoMax, setCupoMax] = useState('');
    const [numSesiones, setNumSesiones] = useState('');
    const [duracionMinutos, setDuracionMinutos] = useState('');
    const [poblacionObjetivoId, setPoblacionObjetivoId] = useState('');
    const [idInstitucion, setIdInstitucion] = useState('');
    const [idSala, setIdSala] = useState('');
    const [idTerapeutaAsignado, setIdTerapeutaAsignado] = useState('');
    const [semestre, setSemestre] = useState('');
    const [estado, setEstado] = useState('pendiente');

    // formulario editar
    const [nuevoNombre, setNuevoNombre] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoIdPrograma, setNuevoIdPrograma] = useState('');
    const [nuevoIdCategoria, setNuevoIdCategoria] = useState('');
    const [nuevoIdCategoriaOriginal, setNuevoIdCategoriaOriginal] = useState('');
    const [nuevoTipo, setNuevoTipo] = useState('');
    const [nuevoCupoMax, setNuevoCupoMax] = useState('');
    const [nuevoDuracionMinutos, setNuevoDuracionMinutos] = useState('');
    const [nuevaPoblacionObjetivoId, setNuevaPoblacionObjetivoId] = useState('');
    const [nuevoIdInstitucion, setNuevoIdInstitucion] = useState('');
    const [nuevoIdSala, setNuevoIdSala] = useState('');
    const [nuevoIdTerapeutaAsignado, setNuevoIdTerapeutaAsignado] = useState('');
    const [nuevoSemestre, setNuevoSemestre] = useState('');
    const [nuevoEstadoAprobacion, setNuevoEstadoAprobacion] = useState('');
    const [imagenEditarPreview, setImagenEditarPreview] = useState(null);
    const [imagenEditarFile, setImagenEditarFile] = useState(null);

    //formulario horarios
    const [modalHorariosVisible, setModalHorariosVisible] = useState(false);
    const [tallerSeleccionado, setTallerSeleccionado] = useState(null);

    useEffect(() => {
        (async () => { await fetchUsuario(); })();
        cargarTalleres();
        cargarCatalogos();
    }, []);

    const usuarioLegued = getUsuario();

    const cargarTalleres = () => {
        const params = new URLSearchParams();
        if (usuarioLegued?.idUsuario) params.append('idUsuario', usuarioLegued.idUsuario);
        fetch(`${baseURL}/talleresGet.php?${params.toString()}`, { method: 'GET' })
            .then(res => res.json())
            .then(data => { setTalleres(data.talleres || []); setLoading(false); })
            .catch(() => setLoading(false));
    };

    const cargarCatalogos = async () => {
        try {
            const [servRes, instRes, salasRes, usersRes, pobRes, catsRes] = await Promise.all([
                fetch(`${baseURL}/serviciosGet.php`).then(r => r.ok ? r.json() : { servicios: [] }).catch(() => ({ servicios: [] })),
                fetch(`${baseURL}/institucionesGet.php`).then(r => r.ok ? r.json() : { instituciones: [] }).catch(() => ({ instituciones: [] })),
                fetch(`${baseURL}/salasGet.php`).then(r => r.ok ? r.json() : { salas: [] }).catch(() => ({ salas: [] })),
                fetch(`${baseURL}/usuariosGet.php`).then(r => r.ok ? r.json() : { usuarios: [] }).catch(() => ({ usuarios: [] })),
                fetch(`${baseURL}/catalogoGet.php?nombre_catalogo=poblacion`).then(r => r.ok ? r.json() : { catalogo: [] }).catch(() => ({ catalogo: [] })),
                fetch(`${baseURL}/categoriasGet.php`).then(r => r.ok ? r.json() : { categorias: [] }).catch(() => ({ categorias: [] })),
            ]);

            //console.log('Respuesta de usuarios (raw):', (usersRes.usuarios || []).filter(u => u.rol === 'terapeuta'));
            //console.log('Respuesta de categorías (raw):', catsRes);

            // Procesar categorías para manejar diferentes estructuras de respuesta
            let categoriasData = [];
            if (Array.isArray(catsRes)) {
                categoriasData = catsRes; // Si la respuesta es un array directo
            } else if (catsRes && typeof catsRes === 'object') {
                // Si es un objeto, buscar arrays en sus propiedades
                categoriasData = catsRes.categorias ||
                    (Array.isArray(catsRes.data) ? catsRes.data :
                        Object.values(catsRes).find(Array.isArray) || []);
            }

            //console.log('Categorías procesadas:', categoriasData);

            setProgramas(servRes.servicios || []);
            setInstituciones(instRes.instituciones || []);
            setSalas(salasRes.salas || []);
            setTodosTerapeutas((usersRes.usuarios || []).filter(u => u.rol === 'terapeuta'));
            setPoblaciones(pobRes.catalogo || []);
            setCategorias(categoriasData);
        } catch (e) {
            // silencioso
        }
    };

    // Refiltrar terapeutas cuando cambia el CESECO (crear)
    useEffect(() => {
        const filtrados = (todosTerapeutas || []).filter(u => String(u.idCategoria) === String(idCategoria) && Number(u.permite_grupal) === 1);


        setTerapeutas(filtrados);
    }, [idCategoria, todosTerapeutas]);

    // Refiltrar terapeutas cuando cambia el CESECO (editar)
    const [terapeutasEditar, setTerapeutasEditar] = useState([]);
    useEffect(() => {
        const filtrados = (todosTerapeutas || []).filter(u => String(u.idCategoria) === String(nuevoIdCategoria) && Number(u.permite_grupal) === 1);
        setTerapeutasEditar(filtrados);
        // Limpiar terapeuta seleccionado al cambiar de categoría
        if (nuevoIdCategoria) {
            setNuevoIdTerapeutaAsignado('');
        }
    }, [nuevoIdCategoria, todosTerapeutas]);

    // Verificar si la categoría ha cambiado
    const categoriaCambiada = nuevoIdCategoria && tallerEditar?.idCategoria &&
        String(nuevoIdCategoria) !== String(tallerEditar.idCategoria);

    const filtrados = (talleres || []).filter(t => {
        const idMatch = String(t.idTaller || '').includes(filtroId);
        const nombreMatch = !filtroNombre || (t.nombre || '').toLowerCase().includes(filtroNombre.toLowerCase());
        const estadoMatch = !filtroEstado || (t.estado || '').includes(filtroEstado);
        return idMatch && nombreMatch && estadoMatch;
    });

    const descargarExcel = () => {
        const data = filtrados.map(t => ({
            Id: t.idTaller,
            Nombre: t.nombre,
            Descripcion: t.descripcion,
            Programa: t.idPrograma,
            Tipo: t.tipo,
            Sesiones: t.numSesiones,
            Estado: t.estado,
            Semestre: t.semestre,
        }));
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Talleres');
        XLSX.writeFile(wb, 'Talleres.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF();
        pdf.text('Lista de Talleres', 10, 10);
        const rows = filtrados.map(t => [t.idTaller, t.nombre, t.descripcion, t.idPrograma, t.tipo, t.numSesiones, t.estado, t.semestre]);
        pdf.autoTable({ head: [['ID', 'Nombre', 'Descripción', 'Programa', 'Tipo', 'Sesiones', 'Estado', 'Semestre']], body: rows });
        pdf.save('talleres.pdf');
    };

    const handleShowMore = () => setVisibleCount(prev => prev + 50);

    const limpiarFormulario = () => {
        setNombre(''); setDescripcion(''); setIdPrograma(''); setTipo('interno'); setCupoMax(''); setNumSesiones(''); setDuracionMinutos('');
        setPoblacionObjetivoId(''); setIdInstitucion(''); setIdSala(''); setIdTerapeutaAsignado(''); setSemestre('');
        setIdCategoria('');
        setImagenPreview(null);
        setImagenFile(null);
    };

    const crearTaller = async () => {
        if (!nombre) {
            Swal.fire('Error', 'Escribe el nombre del taller', 'error');
            return;
        } else if (!idPrograma) {
            Swal.fire('Error', 'Selecciona un programa', 'error');
            return;
        } else if (!tipo) {
            Swal.fire('Error', 'Selecciona un tipo de taller', 'error');
            return;
        } else if (!cupoMax) {
            Swal.fire('Error', 'Escribe el cupo maximo', 'error');
            return;
        } else if (!numSesiones) {
            Swal.fire('Error', 'Escribe el número de sesiones', 'error');
            return;
        } else if (!duracionMinutos) {
            Swal.fire('Error', 'Escribe la duración en minutos', 'error');
            return;
        } else if (!poblacionObjetivoId) {
            Swal.fire('Error', 'Selecciona un tipo de población objetivo', 'error');
            return;
        } else if (!semestre) {
            Swal.fire('Error', 'Selecciona un semestre', 'error');
            return;
        }
        if (tipo === 'externo' && !idInstitucion) {
            Swal.fire('Error', 'Selecciona una institución', 'error');
            return;
        }

        setIsSubmitting(true);
        const payload = {
            idUsuario: usuarioLegued?.idUsuario,
            nombre,
            descripcion,
            idPrograma: Number(idPrograma),
            idCategoria: Number(idCategoria),
            tipo,
            cupoMax: Number(cupoMax),
            numSesiones: Number(numSesiones),
            duracionMinutos: Number(duracionMinutos),
            poblacionObjetivoId: poblacionObjetivoId ? Number(poblacionObjetivoId) : null,
            idInstitucion: tipo === 'externo' ? Number(idInstitucion) : null,
            idSala: idSala ? Number(idSala) : null,
            idTerapeutaAsignado: idTerapeutaAsignado ? Number(idTerapeutaAsignado) : null,
            semestre,
            estado
        };
        try {
            const res = await fetch(`${baseURL}/talleresPost.php`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            const data = await res.json();
            if (data.error) {
                Swal.fire('Error', data.error, 'error');
                return;
            }
            // Subir imagen si se seleccionó
            if (imagenFile) {
                const fd = new FormData();
                fd.append('idTaller', data.idTaller);
                fd.append('imagen1', imagenFile);
                await fetch(`${baseURL}/tallerImagePut.php`, { method: 'POST', body: fd });
            }
            Swal.fire('¡Éxito!', 'Taller creado correctamente', 'success');
            setModalVisible(false);
            limpiarFormulario();
            setErrors({});
            setIsSubmitting(false);
            cargarTalleres();
        } catch (e) {
            Swal.fire('Error', e.message, 'error');
            setIsSubmitting(false);
        }
    };

    const actualizarTaller = async () => {
        if (!nuevoNombre || !nuevoIdPrograma || !nuevoTipo || !nuevoCupoMax || !nuevoDuracionMinutos || !nuevoSemestre) {
            Swal.fire('Error', 'Completa los campos obligatorios', 'error');
            return;
        }
        if (nuevoTipo === 'externo' && !nuevoIdInstitucion) {
            Swal.fire('Error', 'Selecciona una institución', 'error');
            return;
        }

        setIsSubmitting(true);
        const payload = {
            nombre: nuevoNombre,
            descripcion: nuevaDescripcion,
            idPrograma: Number(nuevoIdPrograma),
            idCategoria: nuevoIdCategoria,
            tipo: nuevoTipo,
            cupoMax: Number(nuevoCupoMax),
            numSesiones: tallerEditar.numSesiones,
            duracionMinutos: Number(nuevoDuracionMinutos),
            poblacionObjetivoId: nuevaPoblacionObjetivoId ? Number(nuevaPoblacionObjetivoId) : null,
            idInstitucion: nuevoTipo === 'externo' ? Number(nuevoIdInstitucion) : null,
            idSala: nuevoIdSala ? Number(nuevoIdSala) : null,
            idTerapeutaAsignado: nuevoIdTerapeutaAsignado ? Number(nuevoIdTerapeutaAsignado) : null,
            semestre: nuevoSemestre,
            estadoAprobacion: nuevoEstadoAprobacion
        };

        try {
            const res = await fetch(`${baseURL}/talleresPut.php?idTaller=${tallerEditar.idTaller}&idUsuario=${usuarioLegued?.idUsuario}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (data.error) {
                Swal.fire('Error', data.error, 'error');
            } else {
                // Subir imagen si se seleccionó
                if (imagenEditarFile) {
                    const fd = new FormData();
                    fd.append('idTaller', tallerEditar.idTaller);
                    fd.append('imagen1', imagenEditarFile);
                    await fetch(`${baseURL}/tallerImagePut.php`, { method: 'POST', body: fd });
                }
                Swal.fire('¡Éxito!', 'Taller actualizado correctamente', 'success');
                setModalEditarVisible(false);
                setIsSubmitting(false);
                cargarTalleres();
            }
        } catch (e) {
            Swal.fire('Error', e.message, 'error');
            setIsSubmitting(false);
        }
    };

    // Reset dependientes cuando cambia CESECO (crear)
    useEffect(() => {
        setIdPrograma('');
        setIdSala('');
    }, [idCategoria]);

    // Reset dependientes cuando cambia CESECO (editar) - solo si no estamos abriendo el modal
    const [isOpeningModal, setIsOpeningModal] = useState(false);
    useEffect(() => {
        if (!isOpeningModal && modalEditarVisible) {
            setNuevoIdPrograma('');
            setNuevoIdSala('');
        }
    }, [nuevoIdCategoria, isOpeningModal, modalEditarVisible]);

    const abrirModalEditar = (taller) => {
        //console.log('Abriendo modal de edición para taller:', taller);
        setIsOpeningModal(true);
        setTallerEditar(taller);

        // Asegurarse de que los IDs sean strings
        const categoriaId = taller.idCategoria ? String(taller.idCategoria) : '';
        const programaId = taller.idPrograma ? String(taller.idPrograma) : '';
        const salaId = taller.idSala ? String(taller.idSala) : '';
        const terapeutaId = taller.idTerapeutaAsignado ? String(taller.idTerapeutaAsignado) : '';

        // Guardar los valores originales para referencia
        setNuevoIdCategoriaOriginal(categoriaId);

        // Primero establecer la categoría para que se carguen los programas y salas
        setNuevoIdCategoria(categoriaId);

        // Luego, después de un pequeño retraso para asegurar que los datos se actualicen
        setTimeout(() => {
            // Establecer los valores del formulario
            setNuevoNombre(taller.nombre || '');
            setNuevaDescripcion(taller.descripcion || '');
            setNuevoIdPrograma(programaId);
            setNuevoTipo(taller.tipo || 'interno');
            setNuevoCupoMax(String(taller.cupoMax || ''));
            setNuevoDuracionMinutos(String(taller.duracionMinutos || ''));
            setNuevaPoblacionObjetivoId(String(taller.poblacionObjetivoId || ''));
            setNuevoIdInstitucion(String(taller.idInstitucion || ''));
            setNuevoIdSala(salaId);
            setNuevoIdTerapeutaAsignado(String(taller.idTerapeutaAsignado || ''));
            setNuevoSemestre(taller.semestre || '');
            setNuevoEstadoAprobacion(taller.estadoAprobacion || 'pendiente');
            setImagenEditarPreview(taller.imagen1 || null);
            setSelectedSection('texto');

            // Mostrar el modal después de que todo esté listo
            setModalEditarVisible(true);
            setIsOpeningModal(false);

            // Forzar una actualización adicional para asegurar que los selects se actualicen
            setTimeout(() => {
                setNuevoIdPrograma(programaId);
                setNuevoIdSala(salaId);
            }, 50);
        }, 50);
    };

    const cerrarModalEditar = () => {
        setModalEditarVisible(false);
        setImagenEditarFile(null);
        setImagenEditarPreview(null);
    };

    const abrirModalHorarios = (taller) => {
        setTallerSeleccionado(taller);
        setModalHorariosVisible(true);
    };

    const handleUpdateText = async () => {
        // Validar campos requeridos
        const errors = [];

        if (!nuevoIdPrograma) {
            errors.push('programa');
        }
        if (!nuevoIdSala) {
            errors.push('sala');
        }

        // Si la categoría ha cambiado, validar terapeuta
        if (categoriaCambiada && !nuevoIdTerapeutaAsignado) {
            errors.push('terapeuta');
        }

        if (errors.length > 0) {
            const errorMessage = `Por favor selecciona ${errors.join(', ').replace(/,([^,]*)$/, ' y$1')}`;
            Swal.fire('Error', errorMessage, 'error');
            return;
        }

        // Get the category ID from the selected program or the existing one
        const programaSeleccionado = programas.find(p => String(p.idServicio) === String(nuevoIdPrograma));
        const idCategoria = programaSeleccionado ? programaSeleccionado.idCategoria : (tallerEditar.idCategoria || '');

        const payload = {
            nombre: nuevoNombre !== '' ? nuevoNombre : tallerEditar.nombre,
            descripcion: nuevaDescripcion !== '' ? nuevaDescripcion : tallerEditar.descripcion,
            idPrograma: nuevoIdPrograma !== '' ? Number(nuevoIdPrograma) : tallerEditar.idPrograma,
            idCategoria: idCategoria, // Add idCategoria to the payload
            tipo: nuevoTipo !== '' ? nuevoTipo : tallerEditar.tipo,
            cupoMax: nuevoCupoMax !== '' ? Number(nuevoCupoMax) : tallerEditar.cupoMax,
            duracionMinutos: nuevoDuracionMinutos !== '' ? Number(nuevoDuracionMinutos) : tallerEditar.duracionMinutos,
            poblacionObjetivoId: nuevaPoblacionObjetivoId !== '' ? Number(nuevaPoblacionObjetivoId) : tallerEditar.poblacionObjetivoId,
            idInstitucion: nuevoIdInstitucion !== '' ? Number(nuevoIdInstitucion) : tallerEditar.idInstitucion,
            idSala: nuevoIdSala !== '' ? Number(nuevoIdSala) : (tallerEditar.idSala || null),
            idTerapeutaAsignado: nuevoIdTerapeutaAsignado !== '' ? Number(nuevoIdTerapeutaAsignado) : (tallerEditar.idTerapeutaAsignado || null),
            semestre: nuevoSemestre !== '' ? nuevoSemestre : tallerEditar.semestre,
            estadoAprobacion: nuevoEstadoAprobacion !== '' ? nuevoEstadoAprobacion : (tallerEditar.estadoAprobacion || 'pendiente'),
        };

        try {
            // Add logging for debugging
            console.log('Updating workshop with payload:', payload);

            const response = await fetch(`${baseURL}/talleresPut.php?idTaller=${tallerEditar.idTaller}&idUsuario=${usuarioLegued?.idUsuario}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const data = await response.json();
            if (data.error) {
                Swal.fire('Error', data.error, 'error');
            } else {
                Swal.fire('¡Éxito!', data.mensaje, 'success');
                cargarTalleres();
                cerrarModalEditar();
            }
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
        }
    };

    const handleUpdateImage = async () => {
        if (!imagenEditarFile) {
            Swal.fire('Advertencia', 'Selecciona una imagen', 'warning');
            return;
        }
        const formData = new FormData();
        formData.append('idTaller', tallerEditar.idTaller);
        formData.append('imagen1', imagenEditarFile);

        try {
            const response = await fetch(`${baseURL}/tallerImagePut.php`, {
                method: 'POST',
                body: formData
            });
            const data = await response.json();
            if (data.error) {
                Swal.fire('Error', data.error, 'error');
            } else {
                Swal.fire('¡Éxito!', data.mensaje, 'success');
                cargarTalleres();
                cerrarModalEditar();
            }
        } catch (error) {
            Swal.fire('Error', error.message, 'error');
        }
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    return (
        <div>
            <div className='deFlexContent'>
                <div className='deFlex2'>
                    {(['coord_programa', 'admin', 'coord_ceseco'].includes(usuarioLegued?.rol)) && (
                        <button className='excel' onClick={() => setModalVisible(true)}><FontAwesomeIcon icon={faPlus} /> Agregar</button>
                    )}
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <button>{String(filtrados.length)} / {String(talleres.length)}</button>
                    </div>
                    <div className='inputsColumn'>
                        <input type='number' value={filtroId} onChange={e => setFiltroId(e.target.value)} placeholder='Id' />
                    </div>
                    <div className='inputsColumn'>
                        <input type='text' value={filtroNombre} onChange={e => setFiltroNombre(e.target.value)} placeholder='Nombre' />
                    </div>
                    <div className='inputsColumn'>
                        <select value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
                            <option value=''>Estado</option>
                            <option value='activo'>Activo</option>
                            <option value='inactivo'>Inactivo</option>
                        </select>
                    </div>
                    <button className='reload' onClick={cargarTalleres}><FontAwesomeIcon icon={faSync} /></button>
                </div>
            </div>
            {modalVisible && (
                <div className="modal-taller">
                    <div className="modal-taller-content">
                        <div className="modal-taller-header">
                            <h2 style={{ color: 'white' }}>Nuevo Taller</h2>
                            <button className="modal-taller-close" onClick={() => { setModalVisible(false); }}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className='sectiontext' style={{ display: 'flex' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre (*)</legend>
                                    <input type='text' value={nombre} onChange={e => setNombre(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Descripción</legend>
                                    <input type='text' value={descripcion} onChange={e => setDescripcion(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>CESECO (*)</legend>
                                    <select
                                        value={idCategoria || ''}
                                        onChange={e => setIdCategoria(e.target.value)}
                                        className="form-select"
                                    >
                                        <option value=''>Seleccione un CESECO</option>
                                        {Array.isArray(categorias) && categorias.length > 0 ? (
                                            categorias.map(c => {
                                                const id = String(c.idCategoria || c.id || '');
                                                const nombre = c.categoria || c.nombre || `CESECO ${id}`;
                                                return (
                                                    <option key={`cat-${id}`} value={id}>
                                                        {nombre}
                                                    </option>
                                                );
                                            })
                                        ) : (
                                            <option disabled>No hay CESECOs disponibles</option>
                                        )}
                                    </select>

                                </fieldset>
                                <fieldset>
                                    <legend>Programa (*)</legend>
                                    <select value={idPrograma || ''} onChange={e => setIdPrograma(e.target.value)} disabled={!idCategoria}>
                                        <option value=''>Seleccione</option>
                                        {programas
                                            .filter(p => String(p.idCategoria) === String(idCategoria))
                                            .map(p => (<option key={p.idServicio} value={String(p.idServicio)}>{p.titulo}</option>))}
                                    </select>
                                    {errors.idPrograma && <span className="error-message">{errors.idPrograma}</span>}
                                </fieldset>
                                <fieldset>
                                    <legend>Tipo de Taller (*)</legend>
                                    <select
                                        value={tipo}
                                        onChange={e => setTipo(e.target.value)}
                                    >
                                        <option value='interno'>Interno</option>
                                        <option value='externo'>Externo</option>
                                    </select>
                                </fieldset>
                                {tipo === 'externo' && (
                                    <fieldset>
                                        <legend>Institución (*)</legend>
                                        <select value={idInstitucion || ''} onChange={e => setIdInstitucion(e.target.value)}>
                                            <option value=''>Seleccione</option>
                                            {instituciones.map(i => (<option key={i.idInstitucion} value={String(i.idInstitucion)}>{i.nombre}</option>))}
                                        </select>
                                    </fieldset>
                                )}
                                <fieldset>
                                    <legend>Cupo máximo (*)</legend>
                                    <input type='number' value={cupoMax} onChange={e => setCupoMax(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Número de sesiones (*)</legend>
                                    <input type='number' value={numSesiones} onChange={e => setNumSesiones(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Duración por sesión (min) (*)</legend>
                                    <input type='number' value={duracionMinutos} onChange={e => setDuracionMinutos(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Población objetivo</legend>
                                    <select value={poblacionObjetivoId || ''} onChange={e => setPoblacionObjetivoId(e.target.value)}>
                                        <option value=''>Seleccione</option>
                                        {poblaciones.map(p => (<option key={p.id} value={String(p.id)}>{p.nombre}</option>))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Semestre (*)</legend>
                                    <input type='text' placeholder='Ej.2025-1' value={semestre} onChange={e => setSemestre(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Sala</legend>
                                    <select value={idSala || ''} onChange={e => setIdSala(e.target.value)} disabled={!idCategoria}>
                                        <option value=''>Seleccione</option>
                                        {salas
                                            .filter(s => String(s.idTienda) === String(idCategoria))
                                            .map(s => (<option key={s.idSala} value={String(s.idSala)}>{s.nombre}</option>))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Terapeuta asignado</legend>
                                    <select value={idTerapeutaAsignado || ''} onChange={e => setIdTerapeutaAsignado(e.target.value)} disabled={!idCategoria}>
                                        <option value=''>Seleccione</option>
                                        {terapeutas.map(t => (<option key={t.idUsuario} value={String(t.idUsuario)}>{t.nombre}</option>))}
                                    </select>
                                </fieldset>
                            </div>


                            {/* Sección 5: Institución (solo para externos) */}
                            {tipo === 'externo' && (
                                <div className="form-section">
                                    <h3 className="section-title">Institución Externa</h3>
                                    <div className="form-grid">
                                        <div className="form-group">
                                            <label className="form-label required">Institución</label>
                                            <select
                                                className="form-select"
                                                value={idInstitucion}
                                                onChange={e => setIdInstitucion(e.target.value)}
                                            >
                                                <option value=''>Seleccione una institución</option>
                                                {instituciones.map(i => (<option key={i.idInstitucion} value={i.idInstitucion}>{i.nombre}</option>))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Sección 5: Imagen */}
                            <div className="form-section">
                                <h3 className="section-title">Imagen del Taller</h3>
                                <div className="image-upload-container">
                                    <input
                                        type='file'
                                        id='imagenTaller'
                                        accept='image/*'
                                        style={{ display: 'none' }}
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) { setImagenFile(file); setImagenPreview(URL.createObjectURL(file)); }
                                        }}
                                    />
                                    <label htmlFor='imagenTaller' className={`image-upload-label ${imagenPreview ? 'has-image' : ''}`}>
                                        {imagenPreview ? (
                                            <div className="image-preview">
                                                <img src={imagenPreview} alt='Vista previa' />
                                                <button
                                                    type='button'
                                                    className='remove-image-btn'
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setImagenPreview(null);
                                                        setImagenFile(null);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="image-upload-placeholder">
                                                <FontAwesomeIcon icon={faImage} />
                                                <span style={{ marginLeft: '10px' }}>Seleccionar imagen</span>
                                                <small>PNG, JPG hasta 5MB</small>
                                            </div>
                                        )}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="modal-taller-footer">
                            <button
                                className="btn-cancel"
                                onClick={() => { setModalVisible(false); }}
                                disabled={isSubmitting}
                            >
                                Cancelar
                            </button>
                            <button
                                className="btn-save"
                                onClick={crearTaller}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <FontAwesomeIcon icon={faSync} className="fa-spin" />
                                        Creando...
                                    </>
                                ) : (
                                    <>
                                        <FontAwesomeIcon icon={faPlus} />
                                        Crear Taller
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

           

            {modalEditarVisible && (
                <div className="modal-taller">
                    <div className="modal-taller-content">
                        <div className="modal-taller-header">
                            <h2 style={{ color: 'white' }}>Editar Taller</h2>
                            <button className="modal-taller-close" onClick={cerrarModalEditar}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <div className='deFlexBtnsModal'>
                            <div style={{ marginLeft: '10px', display: 'flex', gap: '10px' }}>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                                <button
                                    className={selectedSection === 'imagen' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('imagen')}
                                >
                                    Editar Imagen
                                </button>
                            </div>
                        </div>

                        {/* Sección Texto */}
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre (*)</legend>
                                    <input type='text' value={nuevoNombre} onChange={e => setNuevoNombre(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Descripción (*)</legend>
                                    <input type='text' value={nuevaDescripcion} onChange={e => setNuevaDescripcion(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>CESECO (*)</legend>
                                    <select
                                        value={nuevoIdCategoria || ''}
                                        onChange={e => {
                                            //console.log('Nuevo valor seleccionado:', e.target.value); // Debug
                                            setNuevoIdCategoria(e.target.value);
                                        }}
                                        className="form-select"
                                    >
                                        <option value=''>Seleccione un centro</option>
                                        {Array.isArray(categorias) && categorias.map(c => (
                                            <option
                                                key={String(c.idCategoria)}
                                                value={String(c.idCategoria)}
                                            >
                                                {c.categoria || `Categoría ${c.idCategoria}`}
                                            </option>
                                        ))}
                                    </select>

                                </fieldset>
                                <fieldset>
                                    <legend>Programa (*)</legend>
                                    <select
                                        value={nuevoIdPrograma || ''}
                                        onChange={e => setNuevoIdPrograma(e.target.value)}
                                        disabled={!nuevoIdCategoria}
                                    >
                                        <option value=''>Seleccione</option>
                                        {programas && programas.length > 0 && nuevoIdCategoria &&
                                            programas
                                                .filter(p => p && p.idCategoria && String(p.idCategoria) === String(nuevoIdCategoria))
                                                .map(p => (
                                                    <option
                                                        key={p.idServicio}
                                                        value={String(p.idServicio)}
                                                    >
                                                        {p.titulo}
                                                    </option>
                                                ))
                                        }
                                        {programas && programas.length > 0 && nuevoIdCategoria &&
                                            programas.filter(p => p && p.idCategoria && String(p.idCategoria) === String(nuevoIdCategoria)).length === 0 &&
                                            <option disabled>No hay programas disponibles</option>
                                        }
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Tipo (*)</legend>
                                    <select value={nuevoTipo} onChange={e => setNuevoTipo(e.target.value)}>
                                        <option value='interno'>Interno</option>
                                        <option value='externo'>Externo</option>
                                    </select>
                                </fieldset>
                                {nuevoTipo === 'externo' && (
                                    <fieldset>
                                        <legend>Institución (*)</legend>
                                        <select value={nuevoIdInstitucion || ''} onChange={e => setNuevoIdInstitucion(e.target.value)}>
                                            <option value=''>Seleccione</option>
                                            {instituciones.map(i => (<option key={i.idInstitucion} value={String(i.idInstitucion)}>{i.nombre}</option>))}
                                        </select>
                                    </fieldset>
                                )}
                                <fieldset>
                                    <legend>Cupo máximo (*)</legend>
                                    <input type='number' value={nuevoCupoMax} onChange={e => setNuevoCupoMax(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Duración por sesión (min) (*)</legend>
                                    <input type='number' value={nuevoDuracionMinutos} onChange={e => setNuevoDuracionMinutos(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Población objetivo</legend>
                                    <select value={nuevaPoblacionObjetivoId || ''} onChange={e => setNuevaPoblacionObjetivoId(e.target.value)}>
                                        <option value=''>Seleccione</option>
                                        {poblaciones.map(p => (<option key={p.id} value={String(p.id)}>{p.nombre}</option>))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Semestre (*)</legend>
                                    <input type='text' placeholder='2025-1' value={nuevoSemestre} onChange={e => setNuevoSemestre(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Sala</legend>
                                    <select
                                        value={nuevoIdSala || ''}
                                        onChange={e => setNuevoIdSala(e.target.value)}
                                        disabled={!nuevoIdCategoria}
                                    >
                                        <option value=''>Seleccione</option>
                                        {salas && salas.length > 0 && nuevoIdCategoria &&
                                            salas
                                                .filter(s => s && s.idTienda && String(s.idTienda) === String(nuevoIdCategoria))
                                                .map(s => (
                                                    <option
                                                        key={s.idSala}
                                                        value={String(s.idSala)}
                                                    >
                                                        {s.nombre}
                                                    </option>
                                                ))
                                        }
                                        {salas && salas.length > 0 && nuevoIdCategoria &&
                                            salas.filter(s => s && s.idTienda && String(s.idTienda) === String(nuevoIdCategoria)).length === 0 &&
                                            <option disabled>No hay salas disponibles</option>
                                        }
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Terapeuta asignado {categoriaCambiada && <span className='required-asterisk'>*</span>}</legend>
                                    <select
                                        value={nuevoIdTerapeutaAsignado || ''}
                                        onChange={e => setNuevoIdTerapeutaAsignado(e.target.value)}
                                        disabled={!nuevoIdCategoria}
                                        className={categoriaCambiada && !nuevoIdTerapeutaAsignado ? 'required-field' : ''}
                                    >
                                        <option value=''>Seleccione</option>
                                        {terapeutasEditar.length > 0 ? (
                                            terapeutasEditar.map(t => (
                                                <option key={t.idUsuario} value={String(t.idUsuario)}>
                                                    {t.nombre}
                                                </option>
                                            ))
                                        ) : (
                                            <option disabled>No hay terapeutas disponibles</option>
                                        )}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Estado de aprobación</legend>
                                    <select value={nuevoEstadoAprobacion} onChange={e => setNuevoEstadoAprobacion(e.target.value)}>
                                        <option value='pendiente'>Pendiente</option>
                                        <option value='aprobado'>Aprobado</option>
                                        <option value='rechazado'>Rechazado</option>
                                    </select>
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={handleUpdateText}>Guardar cambios</button>
                        </div>

                        {/* Sección Imagen */}
                        <div className='sectiontext' style={{ display: selectedSection === 'imagen' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Imagen actual</legend>
                                    {imagenEditarPreview && (
                                        <img src={imagenEditarPreview} alt='Vista previa' style={{ maxWidth: '200px', marginBottom: '10px' }} />
                                    )}
                                </fieldset>
                                <fieldset>
                                    <legend>Nueva imagen</legend>
                                    <div className='image-container'>
                                        <input type='file' id='imagenEditarTaller' accept='image/*' style={{ display: 'none' }} onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) { setImagenEditarFile(file); setImagenEditarPreview(URL.createObjectURL(file)); }
                                        }} />
                                        <label htmlFor='imagenEditarTaller' className={`image-banner-label ${imagenEditarFile ? 'selectedImage' : ''}`}>
                                            {imagenEditarPreview ? (
                                                <img src={imagenEditarPreview} alt='Vista previa' className='image-banner-prev' />
                                            ) : (
                                                <img src={imageIcon} alt='Seleccionar imagen' className='image-banner' />
                                            )}
                                        </label>
                                        {imagenEditarFile && (
                                            <button type='button' className='eliminar-imagen' onClick={() => { setImagenEditarFile(null); setImagenEditarPreview(tallerEditar.imagen1); }}>Cancelar</button>
                                        )}
                                    </div>
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={handleUpdateImage}>Actualizar imagen</button>
                        </div>
                    </div>
                </div>
            )}

            {modalHorariosVisible && (
                <div className="modal" id='NewDias'>
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Horarios
                                </button>
                            </div>
                            <span className="close" onClick={() => setModalHorariosVisible(false)}>
                                &times;
                            </span>
                        </div>
                        <div id='crearForm'>
                            <TallerDiasData tallerId={tallerSeleccionado?.idTaller} />
                        </div>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Imagen</th>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Programa</th>
                            <th>Tipo</th>
                            <th>Sesiones</th>
                            <th>Semestre</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <></>
                        ) : (
                            filtrados.slice(0, visibleCount).map(t => (
                                <tr key={t.idTaller}>
                                    <td>
                                        {t.imagen1 ? (
                                            <img src={t.imagen1} alt="imagen1" />
                                        ) : (
                                            <span className='imgNonetd'>Sin imagen</span>
                                        )}
                                    </td>
                                    <td>{t.idTaller}</td>
                                    <td>{t.nombre}</td>
                                    <td>{t.idPrograma}</td>
                                    <td>{t.tipo}</td>
                                    <td>{t.numSesiones}</td>
                                    <td>{t.semestre}</td>
                                    <td>{t.estado}</td>
                                    <td>
                                        <button className='editar' onClick={() => abrirModalEditar(t)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <Anchor
                                            className='editar'
                                            onClick={() => abrirModalHorarios(t)}
                                            to={`/dashboard/talleres/${t.idTaller}/horarios`}
                                        >
                                            +
                                        </Anchor>

                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            {filtrados.length > visibleCount && (
                <button onClick={handleShowMore} id='show-more-btn'>Mostrar  más</button>
            )}
            {!loading && filtrados.length === 0 && (
                <p>No hay talleres registrados.</p>
            )}
        </div>
    );
}



